import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import clsx from "clsx";
import { Menu } from "lucide-react";

type Props = {
  children?: React.ReactNode;
  header?: React.ReactNode;
  content?: React.ReactNode;
  clickable?: boolean;
};

const dropDownPanelClasses = clsx(
  "bg-background border border-border rounded-sm shadow-lg p-2 min-w-36"
);

const ContextMenu = ({ children, header, content, clickable }: Props) => {
  return (
    <RadixDropdownMenu.Root>
      <RadixDropdownMenu.Trigger asChild>
      <div
        className={clsx(
          "IconButton flex items-center gap-2",
          clickable && "pointer-events-none opacity-50"
        )}
      >
          <div>{children}</div>
        </div>
      </RadixDropdownMenu.Trigger>
      <RadixDropdownMenu.Portal>
        <RadixDropdownMenu.Content
          className={`DropdownMenuContent ${dropDownPanelClasses}`}
          sideOffset={8}
        >
          {/* Render the header if provided */}
          {header && (
            <div className="DropdownMenuHeader p-2 border-b border-border mb-2">
              {header}
            </div>
          )}
          {/* Render the content */}
          {content}
        </RadixDropdownMenu.Content>
      </RadixDropdownMenu.Portal>
    </RadixDropdownMenu.Root>
  );
};

export default ContextMenu;
